import { Component, OnInit } from '@angular/core';
import { ParkingLotSensor, Sensor, SensorTransaction } from '../../entity';
import { ParkingsService } from '../../service/main/parkings.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sensor-history',
  templateUrl: './sensor-history.component.html',
  styleUrls: ['./sensor-history.component.css']
})
export class SensorHistoryComponent implements OnInit {
  sensor: Sensor;
  sensorTransactions: Array<SensorTransaction> = [];
  loadingState: boolean = false;
  noRecordsState: boolean = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private parkingService: ParkingsService) { }

  ngOnInit() {
    this.sensor = {
      SensorID: this.route.snapshot.data['id']
    };
    this.refresh();
  }

  refresh() {
    this.parkingService.getSensorProfile(this.sensor.SensorID).subscribe(sensor => {
      this.sensor = new Sensor();
      this.sensor.fromObject(sensor);

      this.parkingService.getSensorHistory(this.sensor.SensorID).subscribe(data => {
        this.sensorTransactions = data;
        
        // console.log(`data: ${data.length}`);
        // console.log(`tran: ${this.sensorTransactions.length}`);

        this.loadingState = false;
      }, (err) => {
        this.loadingState = false;
        this.noRecordsState = true;
      });

    }, (err) => {
      this.loadingState = false;
      this.noRecordsState = true;
    });
  }

  getStatus(isOccupied: boolean){
    return `../../../assets/pin/${isOccupied ? 'booked-sensor-pin.png': 'sensor-pin.png'}`;
  }

}
